module.exports = __webpack_public_path__ + "index/img/shouhuo.729bc34a.png";